<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" :large="large" :small="small" class="" :style="">
        <page-type-icon :pageType="page.type"></page-type-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="type in cardTypes.filter(c => c.value == 5)"
        @click="cardType = type.value"
        :key="type.value"
      >
        <v-list-item-icon>
          <v-icon
            :color="type.color"
            :style="type.rotate ? `transform: rotate(${type.rotate})` : null"
            >{{ type.icon }}</v-icon
          >
        </v-list-item-icon>
        <v-list-item-title>{{ type.label }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for="type in cardTypes.filter(c => c.value != 5)"
        @click="cardType = type.value"
        :key="type.value"
      >
        <v-list-item-icon>
          <v-icon
            :color="type.color"
            :style="type.rotate ? `transform: rotate(${type.rotate})` : null"
            >{{ type.icon }}</v-icon
          >
        </v-list-item-icon>
        <v-list-item-title>{{ type.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import cardTypes from './cardTypes';
import PageTypeIcon from './index';
import { mapActions } from 'vuex';
export default {
  props: ['page', 'large', 'small'],
  components: { PageTypeIcon },
  data() {
    return {
      cardTypes
    };
  },
  computed: {
    cardType: {
      get() {
        const type = this.page.type >= 0 ? this.page.type : 1;
        return cardTypes[type];
      },
      set(v) {
        console.log(v);
        this.updatePageType({ pageId: this.page.id, type: v });
      }
    }
  },
  methods: {
    ...mapActions('pages', ['updatePageType'])
  }
};
</script>

<style></style>
